import { createContext } from "react";

// Lets NotFound.js tell App.js's GlobalSeoDefaults that the current route is the
// 404 catch-all, so the global canonical fallback can be skipped for it.
const NotFoundStatusContext = createContext({
  isNotFoundRoute: false,
  setIsNotFoundRoute: () => {},
});

export default NotFoundStatusContext;
